/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignBoxCenterBottom = createReactComponent("outline", "align-box-center-bottom", "IconAlignBoxCenterBottom", [["path", { "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 17h2", "key": "svg-1" }], ["path", { "d": "M9 14h6", "key": "svg-2" }], ["path", { "d": "M10 11h4", "key": "svg-3" }]]);

export { IconAlignBoxCenterBottom as default };
//# sourceMappingURL=IconAlignBoxCenterBottom.mjs.map
